module.exports = __webpack_public_path__ + "static/media/8244 (1).09fa7f02.jpg";